<template>
  <div class="page-content">
    <h1>KMS – Tambah Video</h1>
    <p>Form tambah video (WIP)</p>
  </div>
</template>

<script>
export default {
  name: "KmsVideoAdd",
};
</script>
